import { ProductTagLabelPrinter, RtcProductTagLabelInput } from '@tookdee/thermal-printer-lib-js';

import { RtcTagPrintInfoResponse } from '../models/product-tag.model';

/**
 * หน้าตาเครื่องพิมพ์ที่หน้า RTC รอพิมพ์เรียกใช้ — มี 2 ตัวจริงที่สลับกันตาม toggle Short-Lived Product
 * (`ZmPrinterService` = desktop sticker ผ่าน WebUSB, `RelayPrinterService` = mobile printer ผ่าน Relay)
 */
export interface RtcTagPrinter {
  requestAndConnect(): Promise<void>;
  printRtcProductTags(products: RtcTagPrintInfoResponse[]): Promise<void>;
  disconnect(): Promise<void>;
}

// ค่าทุกตัวมาจาก /RTC/print-info ที่ BE format มาแล้ว — ส่งเข้า lib ตรง ๆ ไม่ต้องแปลงซ้ำ
// lib เป็นคนตัดชื่อสินค้าที่ 20 ตัวอักษร, ใส่วงเล็บให้หน่วย, ใส่ #,### ให้ราคา และ gen QR เอง
function toLabelInputs(products: RtcTagPrintInfoResponse[]): RtcProductTagLabelInput[] {
  return products.map(
    (product) =>
      new RtcProductTagLabelInput(
        product.productName,
        product.unit,
        product.retailPrice,
        product.clearPrice,
        product.expirationDate,
        product.uniqueNumber,
        product.expirationDateTime,
        product.printQty
      )
  );
}

export function buildRtcProductTagLabelsJson(products: RtcTagPrintInfoResponse[]): string {
  return ProductTagLabelPrinter.getInstance().buildRtcProductTagLabels(toLabelInputs(products));
}

/**
 * ป้ายชุดเดียวกันแต่จัดหน้าให้ mobile printer (1 ดวงต่อแถว หน้ากว้าง 384 dots) — คนละ method กับ
 * ทาง WebUSB สลับกันจะได้ป้ายเพี้ยนแบบเงียบ ๆ โดยไม่มี error
 */
export function buildRtcMobileProductTagLabelsJson(products: RtcTagPrintInfoResponse[]): string {
  return ProductTagLabelPrinter.getInstance().buildRtcMobileProductTagLabels(toLabelInputs(products));
}
